export default __webpack_public_path__ + "static/media/BrookshireBrothersCircleLogo.b17480eb.png";